import React from 'react';
import {t} from 'i18next';
import {Trans} from 'react-i18next';
import {Box, Typography, IconButton} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './LeftHeader.scss';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';

const LeftHeader: React.FC = () => {
  return (
    <Box className="session-search-left-header">
      <Typography
        className="typo-text headline3_size"
        data-testid={`left-header-title`}
        tabIndex={0}
      >
        {t('sessionSearch.title')}
      </Typography>
      <ArrTooltipWrapper
        trigger={
          <IconButton
            aria-label="Info"
            sx={{padding: 0, marginTop: '4px'}}
            className="icon-info"
          >
            <InfoOutlinedIcon
              fontSize="medium"
              data-testid="info-svg-left-header"
            />
          </IconButton>
        }
      >
        <Trans
          i18nKey="sessionSearch.titleTooltip"
          components={{
            anchor: (
              <a
                href="https://aurora-review.consilio.com/"
                target="_blank"
                className="session-search-left-info-link"
                data-testid={`left-header-a`}
              />
            ),
          }}
        />
      </ArrTooltipWrapper>
    </Box>
  );
};
export default LeftHeader;
